import { useQuery } from "@tanstack/react-query";
import api from "apis";
import { NotifyMyDeskParams } from "apis/data-contracts";

const useMyDeskNotificationQuery = (
  query: NotifyMyDeskParams,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: api.dashboard.notifyMyDeskKey(query),
    queryFn: () => api.dashboard.notifyMyDesk(query),
    select: (res) => res.data.result,
    enabled: enabled,
  });
};

export default useMyDeskNotificationQuery;
